<template>
  <emd-text-section :title="$t('payment-method.credit-card')">
    <emd-text-content
      v-if="data.installments"
      :title="$t('installments')"
      :content="$t('installments-description', [data.installments?.length])"
    />
    <emd-text-content
      :title="$t('fees')"
      :content="$t('noFees')"
    >
      <template v-if="data.hasFees">
        <a
          class="emd-link url-color"
          @click="showInstallmentsModal"
          >{{ $t('seeFees') }}
        </a>
      </template>
    </emd-text-content>

    <emd-text-content
      :title="$t('operationType')"
      :content="data.operationType"
    />
    <emd-text-content
      :title="$t('description')"
      :content="data.statementDescriptor"
    />
    <installments-modal
      v-if="installmentsModalIsVisible"
      :installments="data.installments"
      @closeClick="closeInstallmentsModal"
    />
  </emd-text-section>
</template>

<script>
import { EmdTextSection, EmdTextContent } from 'emerald-vue/src/components'
import InstallmentsModal from '../../../components/InstallmentsModal'

export default {
  name: 'CreditCardPaymentLinks',

  components: {
    EmdTextSection,
    EmdTextContent,
    InstallmentsModal
  },
  data () {
    return {
      installmentsModalIsVisible: false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    closeInstallmentsModal () {
      this.installmentsModalIsVisible = false
    },
    showInstallmentsModal () {
      this.installmentsModalIsVisible = true
    }
  }
}
</script>

<style scoped>
.url-color {
  color: var(--primrias-purple-100, #146441);
}
</style>

<i18n>
  {
    "pt-BR": {
      "installments": "Parcelamento",
      "installments-description": "Em até {0}x",
      "operationType": "Operação da transação",
      "description": "Texto na fatura",
      "fees": "Detalhes do parcelamento",
      "noFees": "Sem acréscimo no preço",
      "seeFees": "Ver detalhes"
    },
    "en-US": {
      "header": "Payment Methods",
      "installments": "Installments",
      "installments-description": "Until {0}x",
      "operationType": "Transaction operation",
      "description": "Text in invoice",
      "fees": "Installment details",
      "noFees": "No price fees",
      "seeFees": "See fees"
    }
  }
</i18n>
